import { render, staticRenderFns } from "./drugInfoCard.vue?vue&type=template&id=00ca7b76&scoped=true"
import script from "./drugInfoCard.vue?vue&type=script&lang=js"
export * from "./drugInfoCard.vue?vue&type=script&lang=js"
import style0 from "./drugInfoCard.vue?vue&type=style&index=0&id=00ca7b76&prod&lang=scss&scoped=true"
import style1 from "./drugInfoCard.vue?vue&type=style&index=1&id=00ca7b76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ca7b76",
  null
  
)

export default component.exports